/*
 * @Author: Dong
 * @Date: 2022-04-07 17:06:29
 * @LastEditors: zhang lin
 * @LastEditTime: 2022-11-23 15:17:37
 */
import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import List from './List';
import { fileConfig } from 'root/store/actions';

import styles from './index.less';
import { SelectedVersionType, UpdateQueueType } from './types';
import { getExtendPackage } from 'root/services/packageManage';

import { useDispatch, useSelector } from 'react-redux';
import { reducerStates } from 'root/store/types';
import { useIntl } from 'react-intl';
import messages from './messages';

interface PropsType {
  showNames?: string[];
  formValues?: { [x: string]: any }; // 表单默认数据
  defaultDatabase: number; // 是否默认数据库
  uploadQueueChange?: (x: SelectedVersionType | UpdateQueueType[], type: string, hasSupos: boolean) => void;
}

const FileConfig = (props: PropsType, ref: React.Ref<unknown> | undefined) => {
  const dispatch = useDispatch();
  const intl = useIntl();

  const { selectedVersions, systemInfo } = useSelector((state: reducerStates) => state.fileConfig);
  const [dataSource, setDataSource] = useState<any>([]);

  useImperativeHandle(ref, () => ({
    clearData: clearData, // 关闭弹框，清空redux数据
  }));

  // 重置redux数据
  const clearData = () => {
    dispatch(fileConfig.clearData());
  };
  useEffect(() => {
    getPackage();
  }, []);

  // 获取正在上传中的数据
  const getPackage = () => {
    const params = {
      catalog: 'extension',
      archiveId: systemInfo?.archiveId,
      requestType: '1',
    };
    getExtendPackage(params).then((res) => {
      const { data } = res;
      dispatch(fileConfig.setSourceData(data));
      setDataSource(data);
    });
  };

  // 选择版本
  const changeSelect = (id: string, name: string) => {
    dispatch(fileConfig.selectVersion({ [name]: id }));
  };

  return (
    <div className={styles.container}>
      <div className={styles.listBox}>
        {dataSource.length ? (
          <List dataSource={dataSource} selectedVersions={selectedVersions} changeSelect={changeSelect} />
        ) : (
          <span>{intl.formatMessage(messages.null)}</span>
        )}
      </div>
    </div>
  );
};

export default forwardRef(FileConfig);
